import StyleSheet from 'react-native-media-query';
import {
  BASESTYLE,
  COLORS,
  FONT_NAMES,
  FixedValue,
  GlobalStyleValues,
  Percentage,
} from '../../constants';
import {IColorTheme} from '../../types/contextTypes/themeContext';
import {normalizeFont, scaleHeight, scaleWidth} from '../../utils/responsive';

export const style = (theme: IColorTheme) =>
  StyleSheet.create({
    subContainer: {
      width: Percentage.PRECENTAGE_100,
      backgroundColor: theme.backgroundColor,
      borderTopLeftRadius: FixedValue.CONSTANT_VALUE_18,
      paddingBottom: scaleHeight(FixedValue.CONSTANT_VALUE_18),
      paddingHorizontal: scaleWidth(FixedValue.CONSTANT_VALUE_20),
      paddingTop: scaleHeight(FixedValue.CONSTANT_VALUE_15),
      shadowColor: COLORS._333333,
      borderTopRightRadius: FixedValue.CONSTANT_VALUE_18,
      shadowOffset: {
        width: FixedValue.CONSTANT_VALUE_0,
        height: -FixedValue.CONSTANT_VALUE_3,
      },
      elevation: FixedValue.CONSTANT_VALUE_3,
      shadowOpacity: FixedValue.CONSTANT_VALUE_03,
    },
    container: {
      paddingBottom: scaleHeight(FixedValue.CONSTANT_VALUE_18),
      width: Percentage.PRECENTAGE_100,
    },
    crossImage: {
      alignItems: GlobalStyleValues.FLEX_END,
    },
    sure: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_24),
      color: theme.color,
      fontFamily: FONT_NAMES.SF_MEDIUM,
    },
    wantDelete2: {
      ...BASESTYLE.textAlignCenter,
      color: theme.color,
      fontFamily: FONT_NAMES.SF_REGULAR,
      marginBottom: scaleHeight(FixedValue.CONSTANT_VALUE_10),
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_16),
      marginHorizontal: scaleWidth(FixedValue.CONSTANT_VALUE_25),
    },
    deleteBinView: {
      ...BASESTYLE.inCenter,
      height: scaleHeight(FixedValue.CONSTANT_VALUE_59),
      width: scaleWidth(FixedValue.CONSTANT_VALUE_59),
      borderRadius: scaleWidth(FixedValue.CONSTANT_VALUE_59),
      marginBottom: scaleHeight(FixedValue.CONSTANT_VALUE_19),
      backgroundColor: COLORS._FFEBEB,
    },
    marginTop20: {
      marginTop: scaleHeight(FixedValue.CONSTANT_VALUE_20),
    },
    yesOrNoButtonView: {
      ...BASESTYLE.inCenter,
      borderRadius: FixedValue.CONSTANT_VALUE_100,
      width: scaleHeight(FixedValue.CONSTANT_VALUE_105),
      height: scaleHeight(FixedValue.CONSTANT_VALUE_48),
    },
    primaryButtonStyle: {
      width: scaleHeight(FixedValue.CONSTANT_VALUE_159_5),
      ...BASESTYLE.inCenter,
      borderRadius: FixedValue.CONSTANT_VALUE_100,
      height: scaleHeight(FixedValue.CONSTANT_VALUE_48),
    },
    primaryButtonStyle2: {
      ...BASESTYLE.inCenter,
      width: scaleHeight(FixedValue.CONSTANT_VALUE_159_5),
      marginRight: scaleWidth(FixedValue.CONSTANT_VALUE_8),
      height: scaleHeight(FixedValue.CONSTANT_VALUE_48),
      borderRadius: FixedValue.CONSTANT_VALUE_100,
    },
    yesButtonLabelstyle: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_14),
      fontFamily: FONT_NAMES.SF_MEDIUM,
      color: COLORS.WHITE,
      lineHeight: normalizeFont(FixedValue.CONSTANT_VALUE_17),
    },
    marginLeft16: {
      marginLeft: scaleWidth(FixedValue.CONSTANT_VALUE_16),
    },
    noButtonBackGroundColor: {
      backgroundColor: COLORS.E9EEFB,
    },
    noButtonLabelstyle: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_14),
      lineHeight: normalizeFont(FixedValue.CONSTANT_VALUE_17),
      color: COLORS.PRIMARY_BLUE,
      fontFamily: FONT_NAMES.SF_MEDIUM,
    },
  });
